export default "__VITE_ASSET__$qvMmMt6__"